import { SPM_API, CODE_API, CLIENT_ACCOUNT, ROSTER_API } from '../baseURL'
import axios from '../config'

const schoolGuid = '78de4a97-5ae6-7d34-9bd4-4c8f180bbd6a';

export default {
  //获取类型列表
  getDigitalBookType() {
    return axios.get(`${SPM_API}/digitalBookType/digitalBookType?fk_school_id=${schoolGuid}`)
  },
  //获取数字教材列表
  getDigitalBookList() {
    return axios.get(`${SPM_API}/digitalBook/list?fk_school_id=${schoolGuid}`)
  },

  //获取推送互动
  getInduction(classGuid) {
    return axios.get(`${CODE_API}/apiv2/induction?FK_ClassGuid=${classGuid}`)
  },
  //加入班级list
  joinList(userGuid) {
    return axios.get(`${CLIENT_ACCOUNT}/user/joined/${userGuid}`)
  },
  //主键获取班级列表
  getClassByPKGuid(classGuidList) {
    return axios.post(`${ROSTER_API}/class/classByPKGuid`, { classGuidList })
  },
  //获取学生成绩
  getScoreList(FK_ClassGuid, PK_UserGuid) {
    return axios.post(`${ROSTER_API}/score/scoreList`, { FK_ClassGuid, PK_UserGuid })
  },
}